/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Language } from './Language';
import {
    LanguageFromJSON,
    LanguageFromJSONTyped,
    LanguageToJSON,
    LanguageToJSONTyped,
} from './Language';

/**
 * 
 * @export
 * @interface UserPreferredLanguageResponse
 */
export interface UserPreferredLanguageResponse {
    /**
     * 
     * @type {Language}
     * @memberof UserPreferredLanguageResponse
     */
    preferredLanguage?: Language;
}



/**
 * Check if a given object implements the UserPreferredLanguageResponse interface.
 */
export function instanceOfUserPreferredLanguageResponse(value: object): value is UserPreferredLanguageResponse {
    return true;
}

export function UserPreferredLanguageResponseFromJSON(json: any): UserPreferredLanguageResponse {
    return UserPreferredLanguageResponseFromJSONTyped(json, false);
}

export function UserPreferredLanguageResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPreferredLanguageResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'preferredLanguage': json['preferredLanguage'] == null ? undefined : LanguageFromJSON(json['preferredLanguage']),
    };
}

export function UserPreferredLanguageResponseToJSON(json: any): UserPreferredLanguageResponse {
    return UserPreferredLanguageResponseToJSONTyped(json, false);
}

export function UserPreferredLanguageResponseToJSONTyped(value?: UserPreferredLanguageResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'preferredLanguage': LanguageToJSON(value['preferredLanguage']),
    };
}

